(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Riding-os"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const section = document.getElementById('riding-os-section');
  const stickyContainer = document.querySelector('.sticky-container');
  const deviceMedia = document.querySelectorAll('.device-media');
  const textElements = document.querySelectorAll('.text-element');
  const nameElements = document.querySelectorAll('.device-name');
  const video = document.getElementById('device-video');
  const mainHeading = document.querySelector('.main-heading');

  // ✅ Add your heading images here (frame-wise)
  const headingImages = [
    "https://cdn.shopify.com/s/files/1/0786/5070/4084/files/riding-os.png?v=1760595165",
    "https://cdn.shopify.com/s/files/1/0786/5070/4084/files/riding-os.png?v=1760595165",
    "https://cdn.shopify.com/s/files/1/0786/5070/4084/files/blue-riding-os.png?v=1760603510",
    "https://cdn.shopify.com/s/files/1/0786/5070/4084/files/purple-riding-os.png?v=1760603522",
  ];

  // ✅ Background colors for each frame
  const bgColors = ["#000000", "#000000", "#000000", "#000000"];

  const totalFrames = deviceMedia.length + 1;
  let lastFrameIndex = -1;

  section.style.height = `${totalFrames * 100}vh`;

  function updateAnimation() {
    const rect = section.getBoundingClientRect();

    if (rect.bottom < 0 || rect.top > window.innerHeight) {
      if (!video.paused) video.pause();
      return;
    }

    const scrollPos = -rect.top;
    const scrollableHeight = section.scrollHeight - window.innerHeight;
    let progress = scrollPos / scrollableHeight;
    progress = Math.max(0, Math.min(1, progress));

    const currentFrameIndex = Math.min(totalFrames - 1, Math.floor(progress * totalFrames));

    if (currentFrameIndex !== lastFrameIndex) {

       section.classList.forEach(cls => {
        if (cls.startsWith('frame-')) {
          section.classList.remove(cls);
        }
      });

      // ✅ Add new frame class
      section.classList.add(`frame-${currentFrameIndex}`);
          // ✅ Change section background color
          stickyContainer.style.backgroundColor = bgColors[currentFrameIndex];

      // ✅ Change heading image
      if (headingImages[currentFrameIndex]) {
        mainHeading.src = headingImages[currentFrameIndex];
      }

      if (currentFrameIndex === 0) {
        stickyContainer.classList.add('is-intro');
        deviceMedia.forEach(m => m.classList.remove('active'));
        textElements.forEach(e => e.classList.remove('visible'));
        nameElements.forEach(e => e.classList.remove('visible'));
        if (!video.paused) video.pause();
      } else {
        stickyContainer.classList.remove('is-intro');
        const mediaIndex = currentFrameIndex - 1;
        deviceMedia.forEach((m, i) => {
          if (i === mediaIndex) {
            m.classList.add('active');
            if (m.tagName === 'VIDEO' && video.paused) video.play().catch(e => console.error(e));
          } else {
            m.classList.remove('active');
          }
        });

        if (mediaIndex !== 0 && !video.paused) video.pause();

        const updateElements = elements => {
          elements.forEach(el => {
            parseInt(el.dataset.frame) === currentFrameIndex
              ? el.classList.add('visible')
              : el.classList.remove('visible');
          });
        };
        updateElements(textElements);
        updateElements(nameElements);
      }
      lastFrameIndex = currentFrameIndex;
    }
  }

  updateAnimation();
  window.addEventListener('scroll', updateAnimation);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-stats"] && !Shopify.designMode) return;
  try {
    
 
  const section = document.getElementById('stats-section');
  const counters = document.querySelectorAll('.count');
  let hasCounted = false;

  function formatNumber(num) {
    if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M+';
    if (num >= 1000) return Math.floor(num / 1000) + 'k+';
    return num + '';
  }

  function runCounters() {
    const duration = 2000;

    counters.forEach(counter => {
      const target = +counter.getAttribute('data-target');
      const step = target / (duration / 20);

      const update = () => {
        const current = +counter.innerText.replace(/\D/g, '');
        if (current < target) {
          counter.innerText = formatNumber(Math.ceil(current + step));
          requestAnimationFrame(update);
        } else {
          counter.innerText = formatNumber(target);
        }
      };

      update();
    });
  }

  window.addEventListener('scroll', () => {
    const sectionTop = section.getBoundingClientRect().top;
    const windowHeight = window.innerHeight;

    if (sectionTop < windowHeight && !hasCounted) {
      hasCounted = true;
      runCounters();
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-baner-animated"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // ---- Config ------------------------------------------------------------
    const frameCount = 65;
    const eagerFrames = 2;
    const currentFrame = i =>
      `https://cdn.shopify.com/s/files/1/0786/5070/4084/files/VeydooMax_V6.18.${i + 1}.png`;

    const conn = navigator.connection || navigator.webkitConnection || navigator.mozConnection;
    const saveData = !!(conn && conn.saveData);
    const downlink = conn && typeof conn.downlink === 'number' ? conn.downlink : 10;
    const BG_CONCURRENCY = saveData ? 1 : downlink >= 5 ? 4 : 2;

    window.requestIdleCallback = window.requestIdleCallback || function (cb) {
      return setTimeout(() => cb({ timeRemaining: () => 50 }), 1);
    };

    // ---- Elements ----------------------------------------------------------
    const canvas = document.getElementById('animation-canvas');
    const context = canvas.getContext('2d');
    const scrollContainer = document.getElementById('scroll-container');
    const textLeft = document.getElementById('text-left');
    const textRight = document.getElementById('text-right');
    // const logoverlay = document.querySelector('.logo-overlay');
    // ---- Added: Gradient Elements ------------------------------------------
    const gradientLeft = document.getElementById('gradient-blur-left');
    const gradientRight = document.getElementById('gradient-blur-right');

    // ---- State -------------------------------------------------------------
    const images = new Array(frameCount);
    const loaded = new Array(frameCount).fill(false);
    let firstDrawn = false;
    let allBgQueued = false;

    // ---- Helpers -----------------------------------------------------------
    const createPreloadHint = (url) => {
      try {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = url;
        document.head.appendChild(link);
      } catch {}
    };

    const loadImage = (index, { priority = 'low' } = {}) => {
      return new Promise((resolve, reject) => {
        if (images[index] && loaded[index]) return resolve(images[index]);

        const img = new Image();
        try { img.fetchPriority = priority; } catch {}
        img.src = currentFrame(index);
        img.onload = async () => {
          images[index] = img;
          loaded[index] = true;
          try { await img.decode?.(); } catch {}
          resolve(img);
        };
        img.onerror = (e) => reject(e);
      });
    };

    const setupCanvas = (img) => {
      if (!img) return;
      if (!firstDrawn) {
        canvas.width = img.naturalWidth || img.width;
        canvas.height = img.naturalHeight || img.height;
        context.drawImage(img, 0, 0);
        firstDrawn = true;
      }
    };

    const drawFrame = (frameIndex) => {
      let idx = frameIndex;
      while (idx >= 0 && !loaded[idx]) idx--;
      if (idx < 0) return;

      const img = images[idx];
      if (!img) return;

      if (canvas.width !== (img.naturalWidth || img.width) ||
          canvas.height !== (img.naturalHeight || img.height)) {
        canvas.width = img.naturalWidth || img.width;
        canvas.height = img.naturalHeight || img.height;
      }
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.drawImage(img, 0, 0);
    };

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const maxScrollTop = scrollContainer.scrollHeight - window.innerHeight;
      const scrollFraction = Math.max(0, Math.min(1, scrollTop / maxScrollTop));
      const frameIndex = Math.min(frameCount - 1, Math.floor(scrollFraction * frameCount));

      requestAnimationFrame(() => drawFrame(frameIndex));

      // Text visibility logic
      // if (frameIndex >=2) {
      //   logoverlay.classList.remove('visible');
      // } 
      //  if (frameIndex <= 5) {
      //   logoverlay.classList.add('visible');
      // }
      if (frameIndex >= 22 && frameIndex <= 48) {
        textLeft.classList.add('is-visible');

      } else {
        textLeft.classList.remove('is-visible');
      }

      if (frameIndex >= 56) {
        textRight.classList.add('is-visible');
      } else {
        textRight.classList.remove('is-visible');
      }

      
      
      // ---- Added: Gradient fade-out logic ------------------------------
      const fadeStartFraction = 0.85; // Start fading in the last 15% of the scroll
      let gradientOpacity = 1;

      if (scrollFraction >= fadeStartFraction) {
        // Calculate progress from 0 (start of fade) to 1 (end of scroll)
        const fadeProgress = (scrollFraction - fadeStartFraction) / (1 - fadeStartFraction);
        gradientOpacity = 1 - Math.min(1, Math.max(0, fadeProgress));
      }

      if (gradientLeft) gradientLeft.style.opacity = gradientOpacity;
      if (gradientRight) gradientRight.style.opacity = gradientOpacity;
      // ---- End added logic ---------------------------------------------
    };

    const startRenderLoop = () => {
      handleScroll();
      window.addEventListener('scroll', handleScroll, { passive: true });
    };

    // ---- Eager load first 2 frames ----------------------------------------
    for (let i = 0; i < Math.min(eagerFrames, frameCount); i++) {
      createPreloadHint(currentFrame(i));
    }

    (async () => {
      try {
        const first = await loadImage(0, { priority: 'high' });
        setupCanvas(first);
      } catch {}
      try {
        await loadImage(1, { priority: 'high' });
      } catch {}
      startRenderLoop();
    })();

    // ---- Lazy preload the rest when the section is on screen --------------
    const lazyPreloadRemaining = () => {
      if (allBgQueued) return;
      allBgQueued = true;

      const queue = [];
      for (let i = eagerFrames; i < frameCount; i++) queue.push(i);

      let inFlight = 0;

      const pump = () => {
        if (!queue.length) return;
        while (inFlight < BG_CONCURRENCY && queue.length) {
          const idx = queue.shift();
          inFlight++;

          requestIdleCallback(async () => {
            try {
              await loadImage(idx, { priority: 'low' });
            } catch {} finally {
              inFlight--;
              pump();
            }
          });
        }
      };
      pump();
    };

    const target = document.getElementById('sticky-container');
    if ('IntersectionObserver' in window && target) {
      const io = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            lazyPreloadRemaining();
            io.disconnect();
            break;
          }
        }
      }, { root: null, rootMargin: '200px 0px', threshold: 0.1 });
      io.observe(target);
    } else {
      setTimeout(lazyPreloadRemaining, 800);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-footer"]) return;
  try {
    
  // document.addEventListener('DOMContentLoaded', function () {
  //     const floatBtn = document.getElementById('floating-button');
  //     let offsetX, offsetY, isDragging = false;

  //     const saved = JSON.parse(localStorage.getItem('floatBtnPos'));
  //     if (saved) {
  //       floatBtn.style.left = saved.x + 'px';
  //       floatBtn.style.top = saved.y + 'px';
  //       floatBtn.style.bottom = 'auto';
  //       floatBtn.style.right = 'auto';
  //     }

  //     floatBtn.addEventListener('mousedown', (e) => {
  //       isDragging = true;
  //       offsetX = e.clientX - floatBtn.offsetLeft;
  //       offsetY = e.clientY - floatBtn.offsetTop;
  //       floatBtn.style.cursor = 'grabbing';
  //     });

    
  //     document.addEventListener('mousemove', (e) => {
  //       if (!isDragging) return;
  //       e.preventDefault();
  //       const x = e.clientX - offsetX;
  //       const y = e.clientY - offsetY;
  //       floatBtn.style.left = x + 'px';
  //       floatBtn.style.top = y + 'px';
  //       floatBtn.style.bottom = 'auto';
  //       floatBtn.style.right = 'auto';
  //       floatBtn.style.position = 'fixed';
  //     });

   
  //     document.addEventListener('mouseup', () => {
  //       if (isDragging) {
  //         localStorage.setItem('floatBtnPos', JSON.stringify({
  //           x: floatBtn.offsetLeft,
  //           y: floatBtn.offsetTop
  //         }));
  //       }
  //       isDragging = false;
  //       floatBtn.style.cursor = 'grab';
  //     });
  //   });

// popup newsltter
document.addEventListener("DOMContentLoaded", function() {
  const popup = document.getElementById("popup");
  
  const dontShowBtn = document.getElementById("dontShowBtn"); // "Do Not Show Again" button
  const targetSection = document.querySelector(".parallax-section");
  let popupShown = false;

  // Check if popup should be hidden (24-hour rule)
  const hideUntil = localStorage.getItem("popupHideUntil");
  const now = new Date().getTime();
  if (hideUntil && now < hideUntil) {
    return; // Do not show popup if within 24 hours
  }

  // Observe when target section enters viewport
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !popupShown) {
        popup.style.display = "flex";
        popupShown = true;
      }
    });
  }, { threshold: 0.5 });

  observer.observe(targetSection);

  // Close popup normally
  

  // "Do Not Show Again" button clicked
  if (dontShowBtn) {
    dontShowBtn.addEventListener("click", () => {
      // Hide popup immediately
      popup.style.display = "none";

      // Store 24-hour hide flag
      const expireTime = new Date().getTime() + 7 * 24 * 60 * 60 * 1000; // 7 days
      localStorage.setItem("popupHideUntil", expireTime);
    });
  }
});


   
    const form = document.getElementById("contact_form");
  
  // Check if the form exists before editing
  setTimeout(function() {
    const form = document.getElementById("contact_form");
    if (form) {
      form.action = "/contact#contact_form23"; // ✅ new action URL
      console.log("Form action changed to:", form.action);
    }
  }, 2000); // 2000 milliseconds = 2 seconds



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("scroll", () => {
  const sections = document.querySelectorAll(".parallax-section");
  sections.forEach(section => {
    const bg = section.querySelector(".parallax-background");
    const speed = 0.4;
    const offset = window.scrollY - section.offsetTop;
    bg.style.transform = `translateY(${offset * speed}px)`;
  });
});

  } catch(e) { console.error(e); }
})();
})();
